import React, { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatsService from '../../controllers/ChatController';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

class Faq extends Component {

    constructor(props) {
        super(props)
        this.state = {
            categories: [],
            categoryId: -1,
            questions: [],
            questionId: -1,
            loading: false,
            answer: ""
        };

        this.changeCategory = this.changeCategory.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.setInputValue = this.setInputValue.bind(this);
        this.setAnswer = this.setAnswer.bind(this);
        this.changeElement = createRef();
    }

    changeCategory = e => {



        let categoryId = parseInt(e.target.value);

        this.setState({
            categoryId: categoryId
        });

        if (categoryId !== -1) {
            this.setLoading(true);
            ChatsService.getFaqQuestions(categoryId, this.props.conversationId, questions => {
                let questionsList = [{
                    label: "",
                    value: ""
                }];
                if (questions.data !== null && questions.data.length > 0)
                    questionsList = questionsList.concat(questions.data);
                this.setState({
                    questions: questionsList
                });
                this.setLoading(false);
            })
        }
    };
    questionChange = e => {
        let questionId = e.target.value,
            question = this.state.questions.find(x => x.label === questionId)

        this.setState({
            questionId: e.target.value
        });

        if (question != null) {
            this.setState({
                answer: question.value
            });
        }

    }
    setAnswer(e) {
        e.preventDefault();
        this.setState({
            answer: e.target.value
        });
    }
    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    showModal = e => {
        this.setLoading(true);

        let user = JSON.parse(localStorage.getItem("fc-logged"));

        ChatsService.getFaqCategories(user.userId, this.props.conversationId, categories => {
            let categoriesList = [{
                id: -1,
                name: ""
            }];
            if (categories.data !== null && categories.data.length > 0)
                categoriesList = categoriesList.concat(categories.data);
            this.setState({
                categories: categoriesList
            });
            this.setLoading(false);
        })
    }

    setInputValue = e => {
        this.props.setInputValue(this.state.answer);
        this.props.toggleModal();
    }

    render() {
        return (<Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
            <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                <Modal.Header >
                    <Modal.Title>{this.props.t("frequentquestions")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-4" controlId="categories">
                                    <Form.Label>{this.props.t("category")}</Form.Label>
                                    <Form.Select onChange={this.changeCategory} value={this.state.categoryId}>
                                        {
                                            this.state.categories.map(elem => {
                                                return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="fqQuestions">
                                    <Form.Label>{this.props.t("question")}</Form.Label>
                                    <Form.Select onChange={this.questionChange} value={this.state.questionId} >
                                        {
                                            this.state.questions.map(elem => {
                                                return <option key={elem.label} value={elem.label} >{elem.label}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="fqAnwer">
                                    <Form.Label>{this.props.t("answer")}</Form.Label>
                                    <Form.Control as="textarea" rows={3} onChange={this.setAnswer} value={this.state.answer} />
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.setInputValue}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal >)
    }
}


export default withTranslation()(Faq);